export default __webpack_public_path__ + "static/media/zlcBackground.87fb7706.png";